import styled from 'styled-components';
import { ModalFooter } from '@visionplanner/ui-react-material';

/**
 * Styles for modal when rendered with stepper component
*/
export const StyledModalStepper = styled.div`
    && {
        .mdc-dialog .mdc-dialog__scrim {
            background-color: ${({ theme }) => theme.colors.desertStorm};
        }
        .mdc-dialog__surface {
            height: 100%;
            width: 100vw;
        }
        .mdc-dialog__content {
            padding: 10px 40px;
            color: ${({ theme }) => theme.blackText};
            input[type=number]::-webkit-inner-spin-button, 
            input[type=number]::-webkit-outer-spin-button { 
                appearance: none;
                margin: 0;
            }
        }
    }
    && .mdc-select__native-control  {
        padding-right: ${({ theme }) => theme.paddings.xlarge};
    }
`;

/**
 * Styles for buttons when rendered with stepper insie modal
*/
export const StyledModalFooter = styled(ModalFooter)`
&&.mdc-dialog__actions {
    border-top: 0;
    button {
        margin-right: 10px;
    }
}
`;
